const actions = {
  fillLeaveData({ commit }, payload) {
    commit('setLeave', payload);
  },
};

export default actions;
